import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import './AdminDashboard.css';

function AdminDashboard() {
  return (
    <div className="admin-dashboard">
      {/* Admin Sidebar */}
      <div className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h3>TeachMeGo Admin</h3>
        </div>
        <nav className="admin-sidebar-nav">
          <Link to="/admin" className="admin-sidebar-button">Admin Home</Link>
          <Link to="/admin/applications" className="admin-sidebar-button">Manage Applications</Link>
          <Link to="/admin/courses" className="admin-sidebar-button">Manage Courses</Link>
          <Link to="/admin/payments" className="admin-sidebar-button">Manage Payments</Link>
        </nav>
      </div>

      {/* Main content */}
      <div className="admin-main-content">
        <Outlet />
      </div>
    </div>
  );
}

export default AdminDashboard;
